<mat-chip-list>
    <mat-chip class="zonar-loading-spinner">
        <mat-spinner diameter="30" color="accent"></mat-spinner>
        <h3>{{translationService.get(translations.appProgressSpinner.loading) | async | translate }}</h3>
    </mat-chip>
</mat-chip-list>
